/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 9,
    height: 16,
    viewBox: '0 0 9 16',
    data: '<path pid="0" d="M7.86 15L1 8l6.86-7" _stroke="#D90E15" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
